module.exports = __webpack_public_path__ + "static/media/turntable-bottom.505c3250.png";